import { render, staticRenderFns } from "./expand-button.vue?vue&type=template&id=0acfed7e&scoped=true&"
import script from "./expand-button.vue?vue&type=script&lang=js&"
export * from "./expand-button.vue?vue&type=script&lang=js&"
import style0 from "./expand-button.vue?vue&type=style&index=0&id=0acfed7e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0acfed7e",
  null
  
)

export default component.exports